module.exports = __webpack_public_path__ + "img/right-5.0662fd93.png";